import axios from 'axios'

const API_URL = `${process.env.REACT_APP_API_URL}`

const LatestForecast = {
  latestForecast(data) {
    return axios({
      method: 'post',
      url: `${API_URL}/latest`,
      data,
    })
  },
}

export default LatestForecast
